import { useTranslation } from "react-i18next";
import { AlertTriangle } from "lucide-react";
import { formatCurrency } from "@/lib/utils";

export const EmergencyLoanAlert = ({ data }) => {
  const { t } = useTranslation();
  if (!data?.balance) return null;

  const ratePct = ((data.rate || 0) * 100).toFixed(0);

  return (
    <div
      className="rounded-lg border border-rose-300 bg-rose-50 p-4 animate-fade-in"
      data-testid="emergency-loan-alert"
    >
      <div className="flex items-start gap-3">
        <AlertTriangle className="w-5 h-5 text-rose-600 shrink-0 mt-0.5" />
        <div className="space-y-2">
          <p className="font-semibold text-rose-900">
            {data.triggered_this_quarter
              ? t("emergencyLoan.triggeredTitle")
              : t("emergencyLoan.outstandingTitle")}
          </p>
          <p className="text-sm text-rose-800">
            {data.triggered_this_quarter
              ? t("emergencyLoan.body", {
                  amount: formatCurrency(data.amount_this_quarter),
                  rate: ratePct,
                })
              : t("emergencyLoan.outstandingBody", {
                  amount: formatCurrency(data.balance),
                  rate: ratePct,
                })}
          </p>
          <div className="flex flex-wrap gap-x-8 gap-y-1 text-sm">
            <span className="text-rose-800">
              {t("emergencyLoan.balance")}:{" "}
              <span className="font-mono font-semibold" data-testid="emergency-loan-balance">
                {formatCurrency(data.balance)}
              </span>
            </span>
            <span className="text-rose-800">
              {t("emergencyLoan.quarterlyCost")}:{" "}
              <span className="font-mono font-semibold" data-testid="emergency-loan-quarterly-cost">
                {formatCurrency(data.quarterly_interest)}
              </span>
            </span>
            <span className="text-rose-800">
              {t("emergencyLoan.annualCost")}:{" "}
              <span className="font-mono font-semibold">{formatCurrency(data.annual_interest)}</span>
            </span>
          </div>
          <p className="text-xs text-rose-700">{t("emergencyLoan.howToClear")}</p>
        </div>
      </div>
    </div>
  );
};
